import { render, staticRenderFns } from "./HoldTime.vue?vue&type=template&id=463580c6&"
import script from "./HoldTime.vue?vue&type=script&lang=js&"
export * from "./HoldTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports